import Box from '@mui/material/Box'
import { useRootLoaderData } from 'components/Root.loader'
import Field from 'components/ui/Field'
import FormInput from 'components/ui/FormInput'
import { ERROR_TEXT } from 'config'
import { useMemo } from 'react'
import { RegisterOptions } from 'react-hook-form'
import { OcrTest } from 'types'
import { HTTP_URL_REGEX } from 'utils/format'

import OcrSettingsUploadBox from './OcrSettingsUploadBox'

type Schema = {
  label: string
  type: string
  name: keyof OcrTest
  rules?: RegisterOptions
  compProps: any
  notEditable?: boolean
  testid: string
}[]

const STATIC_FIELDS: Schema = [
  {
    label: '文書タイプ名',
    type: 'text',
    name: 'documentTypeName',
    rules: {
      required: true,
      maxLength: 100,
      pattern: { value: /\S+/, message: ERROR_TEXT.blank },
    },
    compProps: {
      placeholder: 'Template OCRの読取時に選択する任意の名称',
    },
    testid: 'document-type-name',
  },
  {
    label: 'Secret Key',
    type: 'text',
    name: 'secretKey',
    rules: { required: true },
    compProps: {
      inputProps: {
        autocomplete: 'off',
      },
      placeholder: 'Template OCRで作成したドメインのSecret Keyを入力',
    },
    testid: 'secret-key',
  },
  {
    label: 'APIGW Invoke URL',
    type: 'text',
    name: 'invokeUri',
    rules: {
      required: true,
      pattern: { value: HTTP_URL_REGEX, message: ERROR_TEXT.httpUrlFormat },
    },
    compProps: {
      placeholder: 'Template OCRで作成したドメインのInvoke URLを入力',
    },
    notEditable: true,
    testid: 'apigw-invoke-url',
  },
]

const LABEL_WIDTH = 160
const Step1 = ({ handleFilesAdded, handleFileDeleted, errors, ocrBuilderData, fileData }) => {
  const rootData = useRootLoaderData()

  const groupOptions = useMemo(
    () => [
      { value: '', label: 'すべてのグループ' },
      ...rootData.profile.subGroupInfos.map((group) => ({ value: group.name, label: group.name })),
    ],
    [rootData.profile],
  )

  const schema = useMemo(
    () =>
      STATIC_FIELDS.concat([
        {
          label: 'グループ',
          name: 'subGroup',
          type: 'select',
          compProps: {
            displayEmpty: true,
            placeholder: 'select group',
            options: groupOptions,
          },
          notEditable: true,
          testid: 'group',
        },
      ]),
    [groupOptions],
  )

  const fields = schema.map((item) => (
    <Field
      key={item.name}
      inline
      labelWidth={LABEL_WIDTH}
      label={item.label}
      required={Boolean(item.rules?.required)}
    >
      <FormInput
        name={item.name}
        type={item.type}
        rules={item.rules}
        {...item.compProps}
        defaultValue={ocrBuilderData && ocrBuilderData[item.name]}
        disabled={ocrBuilderData?.ocrBuilderConfigID && item.notEditable}
        testid={item.testid}
      />
    </Field>
  ))

  return (
    <form>
      <Box sx={{ width: 600, maxWidth: '100%' }}>
        {fields}
        <Field inline labelWidth={LABEL_WIDTH} label="サンプルデータ" required>
          <OcrSettingsUploadBox
            handleFilesAdded={handleFilesAdded}
            handleFileDeleted={handleFileDeleted}
            fileData={fileData}
            errors={errors}
          />
        </Field>
      </Box>
    </form>
  )
}

export default Step1
